import {
  CreateReportBody,
  CreateReportResponse,
} from '@eppendorf/vnls-reporting-service-utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { fetcher } from '$shared/fetch';
import { REPORTING_SERVICE_BASE_PATH } from '$shared/utils/api-paths';

import { stabilityReportsQueryKey } from '$features/report-hub/report-hub.api';

export type CreateReportRequest = Extract<
  CreateReportBody,
  { reportType: 'Stability' }
> & { selectedTelemetryIds: string[] };

export const useCreateReport = () => {
  const queryClient = useQueryClient();
  return useMutation<AxiosResponse<CreateReportResponse>, Error, CreateReportRequest>({
    mutationFn: (data: CreateReportRequest) =>
      fetcher.post<CreateReportRequest, CreateReportResponse>(
        REPORTING_SERVICE_BASE_PATH,
        data,
      ),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: [stabilityReportsQueryKey] }),
  });
};
